module.exports = __webpack_public_path__ + "img/signature@2x.1c95769.jpg";